module.exports = __webpack_public_path__ + "static/media/hair (35).a759814f.jpg";